import './notifications.style.sass';
import template from './notifications.tpl.pug';

class NotificationsController {
    /* @ngInject */
    constructor(notificationService) {
        this.notificationService = notificationService;
    }

    disableClose() {
        this.notificationService.disableClose();
    }

    enableClose() {
        this.notificationService.enableClose();
    }

    get notifications() {
        return this.notificationService.notifications;
    }
}

export default {
    selector: 'dbANotifications',
    template: template(),
    controller: NotificationsController
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/notifications.cmpt.js